export {
  useColumnConfig,
  type CustomColumnConfig,
} from '@/hooks/useColumnConfig';

/** Pre-configured table ID for the S&D dashboard tables */
export const SD_TABLE_ID = 'ship-and-debit';
